export default class AuthActionTypes {
  public static SAVE = 'AUTH_SAVE';

  public static REMOVE = 'AUTH_REMOVE';
}
